import { Injectable } from '@angular/core';
import { HttpProvider } from '../../providers/http/http';
import { APP_CONFIG, Env } from '../../environment';
import { DeeplinkProvider } from './deeplink';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { BranchProvider } from '../../providers/analytics/branch';

declare let Iterable;

@Injectable()
export class IterableProvider {

    public onLogin;
    
    constructor(
        private deeplinkProvider: DeeplinkProvider,
        private httpProvider: HttpProvider,
        private branchProvider: BranchProvider
    ) {
    }

    public async isInit() {
        const isInit = await Iterable.isInit();
        return isInit;
    }

    // Iterable
    public onNotificationOpen(mockResponse = null) {
        LoggerProvider.info(this, "onNotificationOpen registered");
        if (mockResponse) {
            this.deeplinkProvider.pushURLHandeler(mockResponse);
        } else {
            Iterable.onNotificationOpen((response) => {
                this.deeplinkProvider.pushURLHandeler(response);
            })
        }
    }

    public onCustomActionClick() {
        LoggerProvider.info(this, "onCustomActionClick registered");
        Iterable.onCustomActionClick((response) => {
            LoggerProvider.info(this, "onCustomActionClick Called:  " + response);
            if (response == "checkBranchDeeplinkInForeground"){
                // OM-7904 - Only work from iOS when application is in Foreground and user click on push notification which contains branch deeplink
                this.branchProvider.checkBranchDeeplinkInForeground();
            }else{
                this.deeplinkProvider.handleCustomAction(response);
            }
        });
    }

    public async registerForPush(onResponse?: any, onError?: any) {
        if (APP_CONFIG.automationTest) {
            onError ? onError(false) : (onResponse ? onResponse(false) : null);
            return;
        }
        LoggerProvider.info(this, 'Iterable registerForPush');
        try {
            const data = await Iterable.registerForPush();
            LoggerProvider.info(this, 'Iterable registerForPush - granted:', { data: data });
            onResponse ? onResponse(data) : null;
        } catch (error) {
            LoggerProvider.error(this, LoggerEvent.PluginError, 'Iterable registerForPush - error:', { error: error });
            onError ? onError(false) : (onResponse ? onResponse(false) : null);
        }
    }

    public isNotificationPermissionGranted(onResponse?: any) {
        Iterable.isNotificationPermissionGranted(onResponse);
    }

    public disablePush() {
        Iterable.disablePush();
    }

    public disableAutoDisplay(){
        Iterable.setAutoDisplayPaused(true);
    }

    public enableAutoDisplay(){
        Iterable.setAutoDisplayPaused(false);
    }
    
    updateNotificationSubscriptions(optIn: boolean, channel: NotificationChannels) {
        let channelType = 'marketing';
        if (channel.search('Transactional') >= 0)
            channelType = 'transactional';
        return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}notifications/${channelType}/subscription`, {
            optIn: optIn,
            notificationChannelType: channel
        });  
    }

}

export var iterableChannels: IterableChannels;
if (APP_CONFIG.env === Env.PROD){
    iterableChannels = {
        "transactionPushEnabled": 30892,
        "marketingPushEnabled": 30888,
        "marketingMailEnabled": 30886
    }
} else {
    iterableChannels = {
        "transactionPushEnabled": 30379,
        "marketingPushEnabled": 26161,
        "marketingMailEnabled": 26159
    }
}
export interface IterableChannels {
    "transactionPushEnabled": Number;
    "marketingPushEnabled": Number;
    "marketingMailEnabled": Number;
}

export interface NativeChannels {
    "transactionPushEnabled": boolean;
    "marketingPushEnabled": boolean;
    "marketingMailEnabled": boolean;
}

export enum NotificationChannels {
    MarketingEmail = "MarketingEmail",
    MarketingPush = "MarketingPush",
    TransactionalPush = "TransactionalPush",
    AdvertisingInApp = "AdvertisingInApp"
}



// WEBPACK FOOTER //
// ./src/providers/marketing/iterable.ts